module.exports = __webpack_public_path__ + "static/media/WaterSensor.6d6acbe0.png";